/**
 * Cmarkdowncolor Component
 * Inline markdown color literal with a leading swatch preview
 */
'use client';
import type { CSSProperties } from 'react';
import { ColorType, getColorValue } from '@/theme/colors';
const SWATCH_SIZE_PX = 14;
const SWATCH_CHECKERBOARD_BACKGROUND = `
  linear-gradient(45deg, rgba(255, 255, 255, 0.16) 25%, transparent 25%),
  linear-gradient(-45deg, rgba(255, 255, 255, 0.16) 25%, transparent 25%),
  linear-gradient(45deg, transparent 75%, rgba(255, 255, 255, 0.16) 75%),
  linear-gradient(-45deg, transparent 75%, rgba(255, 255, 255, 0.16) 75%)
`;
export interface CmarkdowncolorProps {
    hex: string;
    className?: string;
    style?: CSSProperties;
}
export function Cmarkdowncolor({ hex, className, style, }: CmarkdowncolorProps) {
    return (
      <span className={className} style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.35rem',
            verticalAlign: 'baseline',
        }}>
        <span aria-hidden="true" style={{
            position: 'relative',
            width: SWATCH_SIZE_PX,
            height: SWATCH_SIZE_PX,
            flexShrink: 0,
            overflow: 'hidden',
            borderRadius: 999,
            border: `1px solid ${getColorValue(ColorType.White, 0.26)}`,
            backgroundColor: getColorValue(ColorType.Black, 0.36),
            boxShadow: '#ffffff2e 1px 1px 2px 0px inset, #0000008a 0px 1px 3px 0px',
        }}>
          <span aria-hidden="true" style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: SWATCH_CHECKERBOARD_BACKGROUND,
            backgroundPosition: '0 0, 0 4px, 4px -4px, -4px 0px',
            backgroundSize: '8px 8px',
        }}/>
          <span aria-hidden="true" style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: hex,
        }}/>
        </span>
        <span style={{
            fontFamily: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            color: 'inherit',
            ...style,
        }}>
          {hex}
        </span>
      </span>
    );
}
